import { Component, OnInit } from "@angular/core";
import { UsgService } from "../gastro.service";
import { LoginService } from "../login.service";
import { AutotextService } from "../autotext.service";
import { MedicationService } from "../medication.service";
import { ExamsService } from "../exams.service";
import { GastroFormsService } from "../gastro-forms.service";
import { Subscription } from "rxjs";
import { PatientsService } from "../patients.service";

@Component({
    selector: "app-hemorrhoids-treatment",
    templateUrl: "./hemorrhoids-treatment.component.html",
    styleUrls: ["./hemorrhoids-treatment.component.scss"],
    standalone: false
})
export class HemorrhoidsTreatmentComponent implements OnInit {
  showTimeOutForm = false;
  sub = new Subscription();

  constructor(
    public ls: LoginService,
    public gs: UsgService,
    public es: ExamsService,
    public atS: AutotextService,
    public medS: MedicationService,
    public gfs: GastroFormsService,
    private patService: PatientsService
  ) {}

  ngOnInit(): void {
    this.sub = this.es.formLoaded$.subscribe(() => {});
  }

  // AR-24 change 3: AI medical-history summary from the patient's answered questionnaire.
  aiSummaryLoading = false;
  getAiSummary() {
    if (this.aiSummaryLoading) return;
    this.aiSummaryLoading = true;
    this.es.getAiSummary(this.es.ExamType, this.patService.getPat()?.PID).subscribe(
      (res: any) => {
        this.aiSummaryLoading = false;
        if (res && res.summary) {
          const control = this.gs.gastroForm?.get('MedicalBackground');
          if (control) {
            const existing = (control.value || '').toString().trim();
            const previous = (res.previousSummary || '').toString().trim();
            // Replace only our own previously-pasted AI block (exact match), so a
            // doctor's hand-typed notes are never overwritten; otherwise append.
            if (previous && existing === previous) {
              control.setValue(res.summary);
            } else {
              control.setValue(existing ? existing + '\n\n' + res.summary : res.summary);
            }
          }
        } else if (res && res.reason) {
          alert('Could not generate a summary (' + res.reason + ').');
        }
      },
      () => {
        this.aiSummaryLoading = false;
      }
    );
  }

  close() {
    this.showTimeOutForm = false;
    if (this.ls.userType === "nurse" || (this.ls.userType === "doctor" && !this.es.isClosed))
      this.timeOutFormToString();
  }

  timeOutFormToString() {
    let timeOutString = "";

    function addComma() {
      if (timeOutString) {
        timeOutString += ", ";
      }
    }
    if (this.gfs.Form.get("IdentetyMatchBreclate").value == 1) {
      timeOutString += " השם ומספר ת.ז תואמים לפרטי הנבדק/ת ";
      addComma();
    }
    if (this.gfs.Form.get("IdentetyMatchBreclate").value == 0) {
      timeOutString += " השם ומספר ת.ז לא תואמים לפרטי הנבדק/ת ";
      addComma();
    }
    if (this.gfs.Form.get("Identety").value == 1) {
      timeOutString += " הנבדק/ת חזר/ה בקול על ת.ז, שם ושם משפחה ";
      addComma();
    }
    if (this.gfs.Form.get("Identety").value == 0) {
      timeOutString += " הנבדק/ת לא  חזר/ה בקול על ת.ז, שם ושם משפחה ";
      addComma();
    }
    if (this.gfs.Form.get("Guardian").value == 1) {
      timeOutString += ` הזיהוי בוצע ע"י אפוטרופוס ${this.gfs.Form.get("GuardianName").value} ${
        this.gfs.Form.get("GuardianID").value
      } `;
      addComma();
    }
    if (this.gfs.Form.get("IdentetyMatchDocumante").value == 1) {
      timeOutString += " השם ומספר ת.ז תואמים למסמכים ";
      addComma();
    }
    if (this.gfs.Form.get("IdentetyMatchDocumante").value == 0) {
      timeOutString += " השם ומספר ת.ז לא תואמים למסמכים ";
      addComma();
    }
    if (this.gfs.Form.get("Prosthesis").value == 1) {
      timeOutString += " שיניים תותבות ";
      addComma();
    }
    if (this.gfs.Form.get("Prosthesis").value == 0) {
      timeOutString += " ללא שיניים תותבות ";
      addComma();
    }
    if (this.gfs.Form.get("DAC").value == 1) {
      timeOutString += ` תרופות נגד קרישיות דם ${
        this.gfs.Form.get("DACComments").value ? `פרטים: ${this.gfs.Form.get("DACComments").value}` : ""
      }`;
      addComma();
    }

    if (this.gfs.Form.get("DAC").value == 0) {
      timeOutString += " ללא תרופות נגד קרישיות דם ";
      addComma();
    }
    if (this.gfs.Form.get("validconcentFormSedation").value == "valid") {
      timeOutString += " טפסי הסכמה לסדציה: תקין";
      addComma();
    }
    if (this.gfs.Form.get("validconcentFormSedation").value == "notvalid") {
      timeOutString += " טפסי הסכמה לסדציה: לא תקין";
      addComma();
    }
    if (this.gfs.Form.get("validconcentFormAction").value == "valid") {
      timeOutString += " טפסי הסכמה לפעולה: תקין";
      addComma();
    }
    if (this.gfs.Form.get("validconcentFormAction").value == "notvalid") {
      timeOutString += " טפסי הסכמה לפעולה: לא תקין";
      addComma();
    }
    if (this.gfs.Form.get("Equipment").value == 1) {
      timeOutString += ` זמינות ותקינות הציוד בחדר: תקין ${
        this.gfs.Form.get("EquipmentNote").value ? `פירוט: ${this.gfs.Form.get("EquipmentNote").value}` : ""
      }`;
      addComma();
    }
    if (this.gfs.Form.get("Equipment").value == 0) {
      timeOutString += ` זמינות ותקינות הציוד בחדר: לא תקין ${
        this.gfs.Form.get("EquipmentNote").value ? `פירוט: ${this.gfs.Form.get("EquipmentNote").value}` : ""
      }`;
      addComma();
    }
    if (this.gfs.Form.get("MedicationType").value) {
      timeOutString += ` סוג הרדמה : ${this.gfs.Form.get("MedicationType").value}`;
      addComma();
    }
    if (this.gfs.Form.get("medSens").value) {
      timeOutString += " רגישות לחומרים :" + `${this.gfs.Form.get("medSens").value}`;
    }
    if (timeOutString) {
      this.gs.gastroForm.get("TimeOut").patchValue(timeOutString);
    }
  }

  ngOnDestroy(): void {
    if (this.sub) {
      this.sub.unsubscribe();
    }
  }
}
